export const products = [
  {
    id: 1,
    title: "NVIDIA GeForce RTX 4090",
    price: 1599.99,
    category: "Graphic Cards",
    description:
      "Flagship GPU with extreme performance for 4K gaming and rendering.",
    image: "/images/4090.jpg",
  },
  {
    id: 2,
    title: "NVIDIA GeForce RTX 4080 Super",
    price: 1199.99,
    category: "Graphic Cards",
    description: "High-end GPU delivering top-tier performance and efficiency.",
    image: "/images/nvidia_4080.jpg",
  },
  {
    id: 3,
    title: "AMD Radeon RX 7900 XTX",
    price: 999.99,
    category: "Graphic Cards",
    description:
      "Powerful RDNA 3 graphics card built for high-refresh 4K gaming.",
    image: "/images/7900_xtx.jpg",
  },
  {
    id: 4,
    title: "AMD Radeon RX 7800 XT",
    price: 499.99,
    category: "Graphic Cards",
    description: "1440p high-performance GPU with great value and efficiency.",
    image: "/images/7800_xtx.jpg",
  },
  {
    id: 5,
    title: "ASUS ROG Strix G16 (2025) Gaming Laptop",
    price: 1699,
    category: "laptop",
    description:
      "ASUS ROG Strix G16 (2025) Gaming Laptop, 16” ROG Nebula Display 16:10 2.5K 240Hz/3ms, NVIDIA® GeForce RTX™ 5060 Laptop GPU, Intel® Core™ Ultra 9 Processor 275HX, 32GB DDR5, 1TB PCIe SSD, Wi-Fi 7.",
    image: "/images/5.jpg",
  },
  {
    id: 6,
    title: "MSI Vector GP68 HX (i9 / RTX 4080)",
    price: 1652.66,
    category: "laptop",
    description:
      "ASUS ROG Strix G18 (2025) Gaming Laptop, 18” ROG Nebula 16:10 2.5K 240Hz/3ms, NVIDIA® GeForce RTX™ 5070, Intel® Core™ Ultra 9 275HX, 32GB DDR5-5600, 2TB PCIe Gen 4 SSD, Wi-Fi 7, Windows 11 Pro.",
    image: "/images/6.jpg",
  },
  {
    id: 7,
    title: "ASUS TUF Gaming A16 Laptop: AMD Ryzen 7",
    price: 714.99,
    category: "laptop",
    description:
      'ASUS TUF Gaming A16 Laptop: AMD Ryzen 7 7445HS, 16" Full HD+ 145Hz Display, NVIDIA GeForce RTX 4050, 16GB DDR5 RAM, 512GB SSD, Backlit Keyboard, Windows 11.',
    image: "/images/7.jpg",
  },
  {
    id: 8,
    title: "ASUS TUF Gaming A16 Laptop: AMD Ryzen 5",
    price: 720,
    category: "laptop",
    description:
      'ASUS TUF Gaming A16 Laptop: AMD Ryzen 5 7535HS, NVIDIA GeForce RTX 4050, 16GB DDR5 RAM, 512GB PCIe SSD, 16" Full HD+ (1920x1200) 144Hz Display, Windows 11.',
    image: "/images/8.jpg",
  },
  {
    id: 9,
    title: "KOORUI 24 Inch Gaming Monitor 144Hz Full HD",
    price: 79.99,
    category: "Monitors",
    description:
      "KOORUI 24 Inch Gaming Monitor 144Hz Full HD 1920 x 1080p IPS Ultra-Slim Display with HDMI VGA, Adaptive Sync, 99% SRGB, VESA 100x100mm, Eye Care, Tilt, Black, E2411K.",
    image: "/images/9.jpg",
  },
  {
    id: 10,
    title: 'SAMSUNG 32" Odyssey',
    price: 199.99,
    category: "Monitors",
    description:
      'SAMSUNG 32" Odyssey G55C Series QHD 1000R Curved Gaming Monitor, 1ms(MPRT), HDR10, 165Hz, AMD Radeon FreeSync, Eye Care, Glare Free, Sharp Resolution LS32CG550ENXZA.',
    image: "/images/10.jpg",
  },
  {
    id: 11,
    title: 'SAMSUNG 32" UJ59 Series 4K UHD',
    price: 199.99,
    category: "Monitors",
    description:
      'SAMSUNG 32" UJ59 Series 4K UHD (3840x2160) Computer Monitor,VA Panel, HDMI, Display Port, Eye Saver/Flicker Free Mode, FreeSync, LU32J590UQNXZA, Black.',
    image: "/images/11.jpg",
  },
  {
    id: 12,
    title: "32 Inch 4K Computer Monitor",
    price: 999.99,
    category: "Monitors",
    description:
      "32 Inch 4K Computer Monitor, 60Hz UHD Gaming Monitor, VA Panel, HDR, DCI-P3 86%, 100% sRGB, Eye Care, Freesync, HDMI/DP and Built-in Speaker, VESA 75 * 75mm.",
    image: "/images/12.jpg",
  },
  {
    id: 13,
    title: "MSI MAG A750GL PCIE5",
    price: 87.99,
    category: "Power Supply",
    description:
      "MSI MAG A750GL PCIE5, Fully Modular Compact Gaming 750W Power Supply, 80+ Gold, ATX 3.1 & PCIe 5.1 Ready, Native Dual-Color 12V-2x6 Cable, 10 Year Warranty.",
    image: "/images/13.jpg",
  },
  {
    id: 14,
    title: "MSI MAG A850GL PCIE5",
    price: 119.99,
    category: "Power Supply",
    description:
      "MSI MAG A850GL PCIE5, Fully Modular Compact Gaming 850W Power Supply, 80+ Gold, ATX 3.1 & PCIe 5.1 Ready, Native Dual-Color 12V-2x6 Cable, 10 Year Warranty.",
    image: "/images/14.jpg",
  },
  {
    id: 15,
    title: "Thermaltake Toughpower GT 850W",
    price: 84.99,
    category: "Power Supply",
    description:
      "Thermaltake Toughpower GT 850W ATX 3.1 Standard Power Supply; 80 Plus Gold Efficiency; Smart Zero Fan; Native 450W PCIe 5.1 Connector; PS-TPT-0850FNFAGU-3; 5 Year Warranty.",
    image: "/images/15.jpg",
  },
  {
    id: 16,
    title: "ASUS ROG Strix 1000W Platinum",
    price: 214.99,
    category: "Power Supply",
    description:
      "ASUS ROG Strix 1000W Platinum (Fully Modular Power Supply, 80 Plus Platinum Certified, ATX 3.1, Cybenetics Lambda A+, GaN MOSFET, GPU-First Intelligent Voltage Stabilizer, 10-Year Warranty).",
    image: "/images/16.jpg",
  },
  {
    id: 17,
    title: "NVIDIA GeForce RTX 4090",
    price: 1599.99,
    category: "Graphic Cards",
    description:
      "Flagship GPU with extreme performance for 4K gaming and rendering.",
    image: "/images/4090.jpg",
  },
  {
    id: 18,
    title: "NVIDIA GeForce RTX 4080 Super",
    price: 1199.99,
    category: "Graphic Cards",
    description: "High-end GPU delivering top-tier performance and efficiency.",
    image: "/images/nvidia_4080.jpg",
  },
  {
    id: 19,
    title: "AMD Radeon RX 7900 XTX",
    price: 999.99,
    category: "Graphic Cards",
    description:
      "Powerful RDNA 3 graphics card built for high-refresh 4K gaming.",
    image: "/images/7900_xtx.jpg",
  },
  {
    id: 20,
    title: "AMD Radeon RX 7800 XT",
    price: 499.99,
    category: "Graphic Cards",
    description: "1440p high-performance GPU with great value and efficiency.",
    image: "/images/7800_xtx.jpg",
  },
  {
    id: 21,
    title: "ASUS ROG Strix G16 (2025) Gaming Laptop",
    price: 1699,
    category: "laptop",
    description:
      "ASUS ROG Strix G16 (2025) Gaming Laptop, 16” ROG Nebula Display 16:10 2.5K 240Hz/3ms, NVIDIA® GeForce RTX™ 5060 Laptop GPU, Intel® Core™ Ultra 9 Processor 275HX, 32GB DDR5, 1TB PCIe SSD, Wi-Fi 7.",
    image: "/images/5.jpg",
  },
  {
    id: 22,
    title: "MSI Vector GP68 HX (i9 / RTX 4080)",
    price: 1652.66,
    category: "laptop",
    description:
      "ASUS ROG Strix G18 (2025) Gaming Laptop, 18” ROG Nebula 16:10 2.5K 240Hz/3ms, NVIDIA® GeForce RTX™ 5070, Intel® Core™ Ultra 9 275HX, 32GB DDR5-5600, 2TB PCIe Gen 4 SSD, Wi-Fi 7, Windows 11 Pro.",
    image: "/images/6.jpg",
  },
  {
    id: 23,
    title: "ASUS TUF Gaming A16 Laptop: AMD Ryzen 7",
    price: 714.99,
    category: "laptop",
    description:
      'ASUS TUF Gaming A16 Laptop: AMD Ryzen 7 7445HS, 16" Full HD+ 145Hz Display, NVIDIA GeForce RTX 4050, 16GB DDR5 RAM, 512GB SSD, Backlit Keyboard, Windows 11.',
    image: "/images/7.jpg",
  },
  {
    id: 24,
    title: "ASUS TUF Gaming A16 Laptop: AMD Ryzen 5",
    price: 720,
    category: "laptop",
    description:
      'ASUS TUF Gaming A16 Laptop: AMD Ryzen 5 7535HS, NVIDIA GeForce RTX 4050, 16GB DDR5 RAM, 512GB PCIe SSD, 16" Full HD+ (1920x1200) 144Hz Display, Windows 11.',
    image: "/images/8.jpg",
  },
  {
    id: 25,
    title: "KOORUI 24 Inch Gaming Monitor 144Hz Full HD",
    price: 79.99,
    category: "Monitors",
    description:
      "KOORUI 24 Inch Gaming Monitor 144Hz Full HD 1920 x 1080p IPS Ultra-Slim Display with HDMI VGA, Adaptive Sync, 99% SRGB, VESA 100x100mm, Eye Care, Tilt, Black, E2411K.",
    image: "/images/9.jpg",
  },
  {
    id: 26,
    title: 'SAMSUNG 32" Odyssey',
    price: 199.99,
    category: "Monitors",
    description:
      'SAMSUNG 32" Odyssey G55C Series QHD 1000R Curved Gaming Monitor, 1ms(MPRT), HDR10, 165Hz, AMD Radeon FreeSync, Eye Care, Glare Free, Sharp Resolution LS32CG550ENXZA.',
    image: "/images/10.jpg",
  },
  {
    id: 27,
    title: 'SAMSUNG 32" UJ59 Series 4K UHD',
    price: 199.99,
    category: "Monitors",
    description:
      'SAMSUNG 32" UJ59 Series 4K UHD (3840x2160) Computer Monitor,VA Panel, HDMI, Display Port, Eye Saver/Flicker Free Mode, FreeSync, LU32J590UQNXZA, Black.',
    image: "/images/11.jpg",
  },
  {
    id: 28,
    title: "32 Inch 4K Computer Monitor",
    price: 999.99,
    category: "Monitors",
    description:
      "32 Inch 4K Computer Monitor, 60Hz UHD Gaming Monitor, VA Panel, HDR, DCI-P3 86%, 100% sRGB, Eye Care, Freesync, HDMI/DP and Built-in Speaker, VESA 75 * 75mm.",
    image: "/images/12.jpg",
  },
  {
    id: 29,
    title: "MSI MAG A750GL PCIE5",
    price: 87.99,
    category: "Power Supply",
    description:
      "MSI MAG A750GL PCIE5, Fully Modular Compact Gaming 750W Power Supply, 80+ Gold, ATX 3.1 & PCIe 5.1 Ready, Native Dual-Color 12V-2x6 Cable, 10 Year Warranty.",
    image: "/images/13.jpg",
  },
  {
    id: 30,
    title: "MSI MAG A850GL PCIE5",
    price: 119.99,
    category: "Power Supply",
    description:
      "MSI MAG A850GL PCIE5, Fully Modular Compact Gaming 850W Power Supply, 80+ Gold, ATX 3.1 & PCIe 5.1 Ready, Native Dual-Color 12V-2x6 Cable, 10 Year Warranty.",
    image: "/images/14.jpg",
  },
  {
    id: 31,
    title: "Thermaltake Toughpower GT 850W",
    price: 84.99,
    category: "Power Supply",
    description:
      "Thermaltake Toughpower GT 850W ATX 3.1 Standard Power Supply; 80 Plus Gold Efficiency; Smart Zero Fan; Native 450W PCIe 5.1 Connector; PS-TPT-0850FNFAGU-3; 5 Year Warranty.",
    image: "/images/15.jpg",
  },
  {
    id: 32,
    title: "ASUS ROG Strix 1000W Platinum",
    price: 214.99,
    category: "Power Supply",
    description:
      "ASUS ROG Strix 1000W Platinum (Fully Modular Power Supply, 80 Plus Platinum Certified, ATX 3.1, Cybenetics Lambda A+, GaN MOSFET, GPU-First Intelligent Voltage Stabilizer, 10-Year Warranty).",
    image: "/images/16.jpg",
  },
];
